import { Collapse, useEventCallback } from "@material-ui/core";
import FileDownload from "js-file-download";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import SearchSvg from "../../../../assets/images/lupa-white.svg";
import InputDate from "../../../components/Admin/CustomDate";
import CustomizeSelect from "../../../components/Admin/CustomizeSelect";
import CustomTable from "../../../components/Admin/CustomTable";
import Layout from "../../../components/Admin/Layout";
import RadioOption from "../../../components/Admin/RadioOption";
import SearchButton from "../../../components/Admin/SearchButton";
import SearchText from "../../../components/Admin/SearchText";
import SearchWarning from "../../../components/Admin/SearchWarning";
import Button from "../../../components/shared/Button";
import Loading from "../../../components/shared/Loading";
import SimpleModal from "../../../components/shared/MessageModal";
import AdminService from "../../../services/AdminServices";
import "./Evidences.scss";

const Evidences = () => {
  // TABLE STATES
  const [operatorsOption, setOperatorOpt] = useState([]);
  const [pickupPointOption, setPickupPointOpt] = useState([]);
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(10);
  const [perPage, setPerPage] = useState(5);
  // TABLE STATES
  const [openModalError, setModalError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [invalidOc, setInvalidOc] = useState(false);
  const [invalidStores, setInvalidStores] = useState(false);
  const [invalidDni, setInvalidDni] = useState(false);
  const [invalidCud, setInvalidCud] = useState(false);
  const [originOption, setOriginOption] = useState("ripley");
  const [typeOption, setTypeOption] = useState("R");
  const [checkedOption, setCheckedOption] = useState(1);
  const [textSearch, setTextSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [form, setForm] = useState({
    operators: [],
    pickupPoint: [],
  });
  const unmountedRef = useRef(false);
  const unmountedRef2 = useRef(false);
  const didMounRef = useRef(false);

  const onClickPDF = async (ocNumber, row) => {
    try {
      console.log("datos del pdf", ocNumber, row);
      setLoadingScreen(true);
      const excel = await AdminService.exportEvidence(row, typeOption);
      const dateObj = new Date();
      const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
      const date = ("0" + dateObj.getDate()).slice(-2);
      const year = dateObj.getFullYear();
      const fileName = `evidencia_${ocNumber}_${date}${month}${year}.pdf`;
      FileDownload(excel, fileName);
      setLoadingScreen(false);
      // console.log(excel)
    } catch (error) {
      console.error("error ........>", error);
      setLoadingScreen(false);
      setModalError(true);
    }
  };

  const loadOperators = useEventCallback(async () => {
    const operators = await AdminService.getOperators();
    console.log(operators);
    setOperatorOpt(
      operators.map((o) => ({
        ...o,
        value: o.id,
        label: o.name,
        img: o.image,
      }))
    );
  }, [operatorsOption]);

  const loadPickUpPoints = useEventCallback(
    async (operators) => {
      if (operators.length <= 0) return;
      const operatorsIds = operators.map((o) => o.id);
      const opertarosFormatted = operatorsIds.join(",");
      const pickupPoints = await AdminService.getPickUpPoints(
        opertarosFormatted
      );
      console.log(pickupPoints, "PIKCUP POINTS ===>");
      setPickupPointOpt(
        pickupPoints.map((pp) => {
          const operatorFounded = operators.find((o) => o.id === pp.operatorId);
          return {
            ...pp,
            value: pp.id,
            label: pp.title,
            img: operatorFounded.img,
          };
        })
      );
    },
    [pickupPointOption]
  );

  const formatParams = (currentPage, perPage) => {
    let params = {
      originType: originOption,
      type: typeOption,
      startDate: startDate && startDate.format("YYYY-MM-DD"),
      endDate: endDate && endDate.format("YYYY-MM-DD"),
      currentPage,
      perPage,
    };
    switch (checkedOption) {
      case 1:
        params.orderNumber = textSearch;
        break;
      case 2:
        params.dni = textSearch;
        break;
      case 3:
        params.pickupPointIds = form.pickupPoint.map((pp) => pp?.id).join(",");
        break;
      case 4:
        params.cudNumber = textSearch;
      default:
        break;
    }
    return params;
  };

  const fetchEvidences = async (
    currentPage = 1,
    perPage = 5,
    noLoading = false
  ) => {
    try {
      if (!noLoading) setLoading(true);
      setShowFilters(false);
      const params = formatParams(currentPage, perPage);
      const {
        evidences,
        total: { count },
      } = await AdminService.getEvidences(params);
      console.log("count :", count);
      console.log("evidences :", evidences);
      setLoading(false);
      if (evidences.length <= 0) {
        setRows([]);
        return checkedOption === 2
          ? setInvalidDni(true)
          : checkedOption === 1
          ? setInvalidOc(true)
          : checkedOption === 4
          ? setInvalidCud(true)
          : setInvalidStores(true);
      }
      setTotal(count);
      const evidencesMapped = evidences.map((evidence) => {
        if (evidence.originType === "mkp") {
          evidence.originType = "Marketplace";
        } else {
          evidence.originType = "Ripley";
        }
        return evidence;
      });
      setRows(evidencesMapped);
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  };

  const onChangePerPage = async (perPage) => {
    if (perPage <= 0) return;
    setCurrentPage(1);
    await fetchEvidences(1, perPage, true);
  };

  const onChangePage = async (numPage, perPage) => {
    setCurrentPage(numPage);
    fetchEvidences(numPage, perPage, true);
  };

  const handleChange = async (evt, name) => {
    setInvalidOc(false);
    setInvalidDni(false);
    setInvalidStores(false);
    let newForm = { ...form };
    let value = evt.target ? evt.target.value : evt;
    const key = evt.target ? evt.target.name : name;
    console.log(value, key);
    if (key === "operators") {
      loadPickUpPoints(value);
      newForm.pickupPoint = [];
    }
    setForm({
      ...newForm,
      [key]: value,
    });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (perPage !== "") {
        if (didMounRef.current) onChangePerPage(perPage);
        else didMounRef.current = true;
        // console.log(numElem);
      }
    }, 500);

    return () => {
      clearTimeout(timeout); // this guarantees to run right before the next effect
    };
    // eslint-disable-next-line
  }, [perPage]);

  useEffect(() => {
    unmountedRef2.current = false;
    return () => {
      unmountedRef2.current = true;
    };
  }, [loadPickUpPoints]);

  useEffect(() => {
    unmountedRef.current = false;
    loadOperators();
    return () => {
      unmountedRef.current = true;
    };
  }, [loadOperators]);

  const renderClient = (value, index) => {
    return (
      <div style={{ flexDirection: "column", display: "flex" }}>
        <span style={{ marginRight: "auto" }}>{rows[index].clientDni}</span>
        <span style={{ color: "#58595B" }}>{value}</span>
      </div>
    );
  };

  const columns = [
    {
      id: originOption === "ripley" ? "orderNumber" : "suborder",
      label: originOption === "ripley" ? "Orden de compra" : "Sub-pedido",
    },
    {
      id: "clientName",
      label: "Titular",
      format: renderClient,
      cellStyle: { padding: ".2em .5em", justifyContent: "flex-start" },
    },
    { id: "title", label: "Punto de retiro" },
    {
      id: typeOption === "R" ? "receptionDate" : "deliveryDate",
      label: typeOption === "R" ? "Fec. Recepción" : "Fec. Entrega",
      format: (date) => {
        if (date) {
          const d = date.split("T");
          return d.length > 1 ? moment(d[0]).format("DD-MM-YYYY") : date;
        } else {
          return date;
        }
      },
    },
    { id: "originType", label: "Origen" },
    {
      id: "orderNumber",
      label: "PDF",
      type: "download",
      onClickFile: onClickPDF,
    },
  ];

  const cleanFilters = () => {
    setShowFilters(true);
    setTextSearch("");
    setStartDate(null);
    setEndDate(null);
    setForm({
      operators: [],
      pickupPoint: [],
    });
    setOriginOption("ripley");
    setTypeOption("R");
    setCheckedOption(1);
    setRows([]);
  };
  const renderBox = () => {
    switch (checkedOption) {
      case 3:
        return (
          <div className="evidences-container-searchbox-body-combos">
            <div>
              <CustomizeSelect
                label="Operadores de retiro"
                name="operators"
                value={form.operators}
                handleChange={(e, value) => handleChange(value, "operators")}
                multiple={true}
                noMargin
                checkbox
                options={operatorsOption}
              />
            </div>
            <div>
              <CustomizeSelect
                label="Puntos de retiro"
                name="pickupPoint"
                value={form.pickupPoint}
                handleChange={(e, value) => handleChange(value, "pickupPoint")}
                // handleChange={handleChange}
                multiple={true}
                noMargin
                checkbox
                countSelected
                disabled={!form.operators.length}
                options={pickupPointOption}
              />
            </div>
          </div>
        );
      default:
        return (
          <div className="evidences-container-searchbox-body-search">
            <SearchText
              value={textSearch}
              onChange={(text) => {
                setInvalidOc(false);
                setInvalidDni(false);
                setInvalidStores(false);
                setTextSearch(text);
              }}
            />
          </div>
        );
    }
  };

  return (
    <Layout
      title="Post-venta"
      customStyles={{ display: "flex", flexDirection: "column" }}
    >
      <Loading visible={loadingScreen} />
      <SimpleModal
        visible={openModalError}
        closeModal={() => setModalError(false)}
        message="No se pudo completar la descarga. Por favor revise su conexión o intentelo mas tarde."
        type={1}
      />
      <h3 className="evidences-container-title">Solicitud de evidencias</h3>
      {!showFilters && (
        <div className="evidences-container-button-newSearch">
          <Button
            text="nueva búsqueda"
            image={SearchSvg}
            onClick={cleanFilters}
          />
        </div>
      )}
      <div className="evidences-container-searchbox">
        <div
          className={`evidences-container-searchbox-head ${
            showFilters ? "showing" : null
          }`}
          onClick={() => {
            setShowFilters(!showFilters);
            setInvalidDni(false);
            setInvalidOc(false);
            setInvalidStores(false);
          }}
        >
          <p>Buscar evidencias</p>
          <div>
            <img
              className={`${showFilters ? "showing" : null}`}
              src={require("../../../../assets/images/arrow-orange.svg")}
              alt="arrow-orange"
            />
          </div>
        </div>
        <Collapse in={showFilters}>
          <div className="evidences-container-searchbox-body">
            <p>Origen del pedido</p>
            <div className="evidences-container-searchbox-body-options">
              <RadioOption
                label="Ripley"
                isChecked={originOption === "ripley"}
                onClick={() => {
                  setRows([]);
                  setOriginOption("ripley");
                  setTextSearch("");
                  setCheckedOption(1);
                }}
              />
              <RadioOption
                label="Marketplace"
                isChecked={originOption === "mkp"}
                onClick={() => {
                  setRows([]);
                  setOriginOption("mkp");
                  setTextSearch("");
                  setCheckedOption(1);
                }}
              />
            </div>
            <p>Tipo de solicitud</p>
            <div className="evidences-container-searchbox-body-options">
              <RadioOption
                label="Recepción"
                isChecked={typeOption === "R"}
                onClick={() => {
                  setRows([]);
                  setTypeOption("R");
                }}
              />
              <RadioOption
                label="Entrega"
                isChecked={typeOption === "E"}
                onClick={() => {
                  setRows([]);
                  setTypeOption("E");
                }}
              />
              {/* Habilitar codigo para devolucion - falta trabajar el pdf */}
              {/* <RadioOption
                label='Devolución'
                isChecked={typeOption === 'D'}
                onClick={() => {
                  setRows([])
                  setTypeOption('D')
                }}
              /> */}
            </div>
            <p>Buscar por</p>
            <div className="evidences-container-searchbox-body-options">
              <RadioOption
                label="Orden de compra"
                isChecked={checkedOption === 1}
                onClick={() => {
                  setCheckedOption(1);
                  setStartDate(null);
                  setEndDate(null);
                }}
              />
              <RadioOption
                label="DNI del cliente"
                isChecked={checkedOption === 2}
                onClick={() => setCheckedOption(2)}
              />
              <RadioOption
                label="Tienda de retiro"
                isChecked={checkedOption === 3}
                onClick={() => setCheckedOption(3)}
              />
              {originOption === "ripley" && (
                <RadioOption
                  label="Número de CUD"
                  isChecked={checkedOption === 4}
                  onClick={() => setCheckedOption(4)}
                />
              )}
            </div>
            {renderBox()}
            {checkedOption !== 1 && checkedOption !== 4 && (
              <>
                <p>Filtrar por</p>
                <div className="evidences-container-searchbox-body-dates">
                  <InputDate
                    label={`Fec. ${
                      typeOption === "R" ? "recepción" : "entrega"
                    } (Inicio)`}
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                  />
                  <InputDate
                    label={`Fec. ${
                      typeOption === "R" ? "recepción" : "entrega"
                    } (Fin)`}
                    value={endDate}
                    onChange={(date) => setEndDate(date)}
                  />
                </div>
              </>
            )}
            <div className="evidences-container-searchbox-body-button">
              <SearchButton
                text="BUSCAR PEDIDOS"
                onClick={() => fetchEvidences(currentPage, perPage)}
                disabled={
                  ((checkedOption === 1 ||
                    checkedOption === 2 ||
                    checkedOption === 4) &&
                    textSearch.trim() === "") ||
                  (checkedOption === 3 && form.pickupPoint.length <= 0)
                }
              />
            </div>
          </div>
        </Collapse>
      </div>
      <Collapse in={loading}>
        <div className="evidences-container-loading">
          <img
            src={require("../../../../assets/images/loading.gif")}
            className="cargando"
            alt="loading"
          />
          <p>Buscando pedidos</p>
        </div>
      </Collapse>
      {rows.length > 0 && !loading && (
        <>
          <div className="evidences-container-report">
            <p>
              Evidencias de{" "}
              <span className="evidences-container-report-span">
                {typeOption === "R"
                  ? "Recepción"
                  : typeOption === "E"
                  ? "Entrega"
                  : "Devolución"}
              </span>
            </p>
          </div>
          <div
            className={`evidences-container-report-table ${
              showFilters ? "minHeight" : ""
            }`}
          >
            <CustomTable
              columns={columns}
              rows={rows}
              total={total}
              currentPage={currentPage}
              changePage={onChangePage}
              perPage={perPage}
              onChangePerPage={(e) => setPerPage(e.target.value)}
              totalPages={Math.ceil(parseInt(total) / parseInt(perPage))}
            />
          </div>
        </>
      )}
      {invalidDni && (
        <div className="evidences-container-warning">
          <SearchWarning
            title="Titular no encontrado"
            description={`El cliente titular con DNI ${textSearch} no tiene pedidos para retirar en Tambo.`}
            onClose={() => setInvalidDni(false)}
          />
        </div>
      )}
      {invalidOc && (
        <div className="evidences-container-warning">
          <SearchWarning
            title="Pedido no encontrado"
            description={`La orden de compra Nº ${textSearch} no está cargada en Tambo. Valida el pedido en Big Ticket.`}
            onClose={() => setInvalidOc(false)}
          />
        </div>
      )}
      {invalidStores && (
        <div className="evidences-container-warning">
          <SearchWarning
            title="Evidencias no encontradas"
            description={`No se encontraron evidencias en las tiendas seleccionadas ${form.pickupPoint
              .map((pp) => pp?.title)
              .join(", ")}. Valida el pedido en Big Ticket.`}
            onClose={() => setInvalidStores(false)}
          />
        </div>
      )}
      {invalidCud && (
        <div className="evidences-container-warning">
          <SearchWarning
            title="Evidencias no encontradas"
            description={`No se encontraron evidencias con el número de CUD ${textSearch}. Valida el pedido en Big Ticket.`}
            onClose={() => setInvalidCud(false)}
          />
        </div>
      )}
    </Layout>
  );
};

export default Evidences;
